import * as PIXI from "pixi.js";
import {config} from "../../config";

export class BalancePanel extends PIXI.Container {

    private readonly VALUE_TEXT_STYLE: any = {
        fontSize: 20,
        fill: "#fff",
        fontFamily: "RobotoCondensedRegular",
    };
    private readonly TITLE_TEXT_STYLE: any = {
        fontSize: 17,
        fill: "#c8c7c7",
        fontFamily: "RobotoCondensedRegular",
        fontWeight: 600,
        letterSpacing: 1.6,
    };

    private readonly VALUE_TEXT_POSITION = new PIXI.Point(0, 37);
    private readonly DEFAULT_ANCHOR_POINT: any = new PIXI.Point(0.5, 0.5);
    private readonly BACKGROUND_WIDTH = 95;

    private depositTitleText: PIXI.Text;
    private depositValueText: PIXI.Text;
    private steemValue: number;
    private sbdValue: number;
    private currentlyDisplayedCurrency: string = config.baseCurrency;

    constructor() {
        super();
        this.createAndAddTitleText();
        this.createAndAddValueText();
    }

    public updateBalance(steem: number, sbd: number): void {
        this.steemValue = steem;
        this.sbdValue = sbd;
        this.updateValueText();
    }

    public getBalance(currencyType: string): number {
        if (currencyType === config.baseCurrency) {
            return this.steemValue;
        }
        throw new Error("Not Implemented! Currency type does not exist in Balance Panel!");
    }

    public displayCurrencyValue(currencyType: string): void {
        this.currentlyDisplayedCurrency = currencyType;
        this.updateValueText();
    }

    private updateValueText(): void {
        if (this.currentlyDisplayedCurrency === config.baseCurrency) {
            this.depositValueText.text = parseFloat(this.steemValue.toFixed(6)).toString();
        }
    }

    private createAndAddTitleText(): void {
        this.depositTitleText = new PIXI.Text("BALANCE", this.TITLE_TEXT_STYLE);
        this.depositTitleText.anchor = this.DEFAULT_ANCHOR_POINT;
        this.addChild(this.depositTitleText);
    }

    private createAndAddValueText(): void {
        this.depositValueText = new PIXI.Text("", this.VALUE_TEXT_STYLE);
        this.depositValueText.position = this.VALUE_TEXT_POSITION;
        this.depositValueText.anchor = this.DEFAULT_ANCHOR_POINT;
        this.addChild(this.depositValueText);
    }
}



// WEBPACK FOOTER //
// ./src/app/userInterface/BalancePanel.ts